var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3482 0.811707H2.65178C1.18726 0.811707 0 1.99896 0 3.46349V28.5364C0 30.001 1.18726 31.1882 2.65178 31.1882H41.3482C42.8127 31.1882 44 30.001 44 28.5364V3.46349C44 1.99896 42.8127 0.811707 41.3482 0.811707Z",
    fill: "#274D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5093 8.21064V12.5294C30.5093 13.2076 31.059 13.7573 31.7371 13.7573H38.5117C39.1899 13.7573 39.7395 13.2075 39.7395 12.5294V8.21064C39.7395 7.53244 39.1898 6.98279 38.5117 6.98279H31.7372C31.059 6.98279 30.5093 7.53254 30.5093 8.21064Z",
    fill: "#C4573A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34912 5.17004H6.25788C6.63569 5.17004 6.91747 5.18583 7.10313 5.2173C7.28879 5.24878 7.45491 5.31446 7.60149 5.41434C7.74806 5.51421 7.87021 5.64726 7.96792 5.81338C8.06564 5.9795 8.1145 6.16572 8.1145 6.37196C8.1145 6.59558 8.05427 6.80079 7.93372 6.98758C7.81318 7.17436 7.64978 7.31436 7.44354 7.40776C7.73453 7.49241 7.95815 7.63683 8.1145 7.841C8.27085 8.04508 8.34902 8.28505 8.34902 8.56081C8.34902 8.77795 8.29856 8.98917 8.19756 9.19438C8.09655 9.39958 7.95872 9.56354 7.78386 9.68625C7.6091 9.80896 7.39356 9.88441 7.13733 9.91259C6.97666 9.92998 6.58899 9.94078 5.97451 9.9452H4.34912V5.17004ZM5.31323 5.96474V7.06894H5.9451C6.32074 7.06894 6.55423 7.06349 6.64537 7.05269C6.81036 7.03314 6.94011 6.97611 7.03464 6.88168C7.12916 6.78726 7.17633 6.66295 7.17633 6.50876C7.17633 6.36106 7.13564 6.24117 7.05418 6.14881C6.97272 6.05645 6.8517 6.00064 6.69103 5.98109C6.59548 5.97019 6.32084 5.96484 5.86692 5.96484H5.31323V5.96474ZM5.31323 7.86374V9.14063H6.20574C6.55319 9.14063 6.77362 9.13086 6.86692 9.11132C7.01021 9.08529 7.127 9.02177 7.2171 8.92077C7.30721 8.81976 7.35231 8.68465 7.35231 8.51524C7.35231 8.37196 7.31754 8.25028 7.24811 8.1504C7.17867 8.05053 7.07823 7.9778 6.94679 7.93214C6.81534 7.88648 6.53036 7.86374 6.09177 7.86374H5.31323Z",
    fill: "#EBF0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4692 9.9452H12.4204L12.0035 8.86054H10.0947L9.70057 9.9452H8.67773L10.5376 5.17004H11.5572L13.4692 9.9452ZM11.694 8.05598L11.036 6.28401L10.3911 8.05598H11.694Z",
    fill: "#EBF0F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9902 9.9452V5.17004H14.9283L16.8826 8.3589V5.17004H17.7783V9.9452H16.8109L14.8859 6.83123V9.9452H13.9902Z",
    fill: "#EBF0F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.811 9.9452V5.17004H19.7751V7.2905L21.723 5.17004H23.0194L21.2214 7.02995L23.1171 9.9452H21.8696L20.5569 7.7042L19.7751 8.50218V9.9452H18.811Z",
    fill: "#EBF0F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13683 24.5007H2.40039V26.8304H6.13683V24.5007Z",
    fill: "#EBF0F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0654 24.5007H9.17529V26.8304H15.0654V24.5007Z",
    fill: "#EBF0F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5009 24.5007H16.8486V26.8304H23.5009V24.5007Z",
    fill: "#EBF0F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4539 24.5007H25.7017V26.8304H33.4539V24.5007Z",
    fill: "#EBF0F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5991 24.5007H35.9941V26.8304H41.5991V24.5007Z",
    fill: "#EBF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAvatar);
export default __webpack_public_path__ + "static/media/bankAvatar.13d84f5bda34f39f9c97b2c14427d711.svg";
export { ForwardRef as ReactComponent };